import { useState } from "react";
import { useTranslationI18 } from "../../../services/hooks/useTranslationI18";
import styles from "./TextInput.module.scss";

export const TextInput = (
  props: {
    onChange?: (e: any) => void;
    hasClear?: boolean;
    onClear?: () => void;
    extraValidation?: (s: string) => string;
    testid?: string;
  } & React.InputHTMLAttributes<HTMLInputElement>
) => {
  const { t } = useTranslationI18();
  const { onChange, testid } = props;
  const { onClear, hasClear, ...inheritableProps } = props;
  const [error, setError] = useState(null);

  const numberInputOnWheelPreventChange = (e: any) => {
    e.target.blur();
    e.stopPropagation();
    setTimeout(() => {
      e.target.focus();
    }, 0);
  };

  return (
    <div className={styles.custom_input}>
      <div className={styles.input_wrapper}>
        <input
          {...inheritableProps}
          className={error ? styles.error : undefined}
          onChange={(e) => {
            setError(null);
            onChange && onChange(e);
          }}
          onWheel={numberInputOnWheelPreventChange}
          onInvalid={(e) => {
            e.preventDefault();
            const target = e.target as unknown as any;
            let error = target.validationMessage;
            if (error === "Please fill out this field.") {
              error = "Required";
            }
            target.scrollIntoView({ block: "center", behavior: "smooth" });
            setError(error);
          }}
          data-testid={testid}
        />

        {hasClear && (
          <button
            onClick={onClear}
            className={`${styles.clear_button} ${
              props.value ? styles.visible : ""
            }`}
            type="button"
          >
            {t("common:clear")}
          </button>
        )}
      </div>
      {error && (
        <span className={styles.error_text} data-testid={"validation-error"}>
          {error}
        </span>
      )}
    </div>
  );
};
